<template>
  <div class="row text-nowrap m-2 m-sm-4 font-italic">
    <div class="col flex-grow-1 flex-sm-grow-0 site-title-div">
      <div>
        <h1>Админ<strong>ПЛЮС</strong></h1>
        <h2><strong>електронен дневник</strong></h2>
      </div>
    </div>

    <div class="col flex-grow-1 flex-sm-grow-0 align-self-end text-right text-sm-left">
      <div>
        <h2><strong>{{dateDiff}}</strong> години</h2>
        <h2><strong>15</strong> септември</h2>
        <h2>начало на</h2>
        <h2>учебната година</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "september15th-main-component",
  data() {
    return {
      dateDiff: 135
    }
  },
  beforeMount() {
    const today = new Date();
    this.dateDiff = today.getFullYear() - 1921
  }
}
</script>

<style scoped>

</style>
